import useDelayedIsLoading from './utils/useDelayedIsLoading';
import useGlobalIsError from './utils/useGlobalIsError';
import useGlobalIsLoading from './utils/useGlobalIsLoading';
import useLoadingText from './utils/useLoadingText';
import { globalLoadingProgressPercentSelector } from './globalLoadingSlice';
import { Loading } from '@optimization/ssi-common';
import { useAppSelector } from 'app/hooks';

const GlobalLoading = () => {
  const isLoading = useGlobalIsLoading();
  const isError = useGlobalIsError();
  const loadingText = useLoadingText({ isLoading });
  const progressPercent = useAppSelector(globalLoadingProgressPercentSelector);
  const delayedIsLoading = useDelayedIsLoading({ isLoading });

  return (
    <Loading
      isLoading={delayedIsLoading}
      isError={isError}
      loadingText={loadingText}
      progressPercent={progressPercent}
    />
  );
};

export default GlobalLoading;
